import React from 'react';
import { Box } from '@mui/material';
import { keyframes } from '@mui/system';
import { theme } from 'utils/theme';

const TypingIndicator = () => {
    const bounce = keyframes`
        0%, 80%, 100% {
            transform: scale(0);
        }
        40% {
            transform: scale(1.0);
        }
        `;
    const dots = [
        { animationDelay: '0s' },
        { animationDelay: '0.2s' },
        { animationDelay: '0.4s' },
    ];

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '2px',
            }}
        >
            {dots.map((dot, index) => (
                <Box
                    key={index}
                    sx={{
                        width: 8,
                        height: 8,
                        borderRadius: '50%',
                        backgroundColor: theme.palette.grey[500],
                        animation: `${bounce} 1s infinite ease-in-out both`,
                        animationDelay: dot.animationDelay,
                        marginX: '4px',
                    }}
                />
            ))}
        </Box>
    );
};

export default TypingIndicator;